<template>
  <div class="mx-4">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div :class="result">
      <div class="row pb-4">
        <div class="col-12 pb-3 text-center">
          <h4>Excepciones Supervisor</h4>
        </div>
        <div class="col-12" style="display: flex; justify-content: space-between">
          <v-btn color="primary" elevation="1" :disabled="newOffer" @click="Nueva_Oferta">Nueva excepción</v-btn>
          <v-btn color="primary" elevation="1" v-show="!newOffer" @click="Consultar">Consultar</v-btn>
        </div>
      </div>
      <div v-show="!newOffer" class="row">
        <div class="col-12 mt-3">
          <v-card>
            <v-card-title style="display: flex; justify-content: flex-end">
              <v-col cols="12">
                <v-row style="display: flex; align-items: flex-end">
                  <v-col cols="4" class="pa-1">
                    <v-dialog ref="dialogBegin" v-model="modalBegin" :return-value.sync="begin" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details
                          class="pr-2 pb-1"
                        ></v-text-field>
                      </template>
                      <v-date-picker :title-date-format="titleDateFormat" v-model="begin" range locale="es">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalBegin = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="$refs.dialogBegin.save(begin)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.usuario_creacion"
                      label="Supervisor"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.idactividad"
                      label="Codigo de excepción"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.mu"
                      type="number"
                      label="MU"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-autocomplete
                      hide-details
                      solo
                      v-model="send.nomestatus"
                      :items="filter.nomestatus"
                      item-text="name"
                      item-value="id"
                      label="Estatus"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="8" class="pa-1">
                <v-btn elevation="2" @click="cleanFilter">Limpiar</v-btn>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
              </v-col>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :items-per-page="itemsPerPage"
              class="elevation-1"
              disable-sort
              loading-text="Cargando usuarios... Porfavor espere"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <div class="pa-1">
                  <button
                    v-on:click.prevent="Mostrar_Detalle_Solicitud(item.idtiempoextraoferta)"
                    class="btn teleperformance-purpura2 view-details"
                  >
                    Ver detalle
                  </button>
                </div>
              </template>
              <template v-slot:no-data> No hay información disponible </template>
              <template v-slot:no-results> No se obtuvieron resultados </template>
            </v-data-table>
          </v-card>
        </div>
      </div>
      <div v-show="newOffer">
        <hr />
        <div style="display: flex; justify-content: space-evenly; flex-wrap: wrap; gap: 35px">
          <div>
            <div class="row">
              <div class="col-3" style="display: flex; align-items: center">Agente</div>
              <div class="col-9">
                <div style="max-width: 250px">
                  <v-autocomplete
                    hide-details
                    v-model="formNew.agente"
                    :items="agentes"
                    @change="agenteSeleccionado()"
                    item-text="nomagenteSistema"
                    return-object
                    label="Seleccionar"
                    solo
                    dense
                    no-data-text="No se obtuvieron resultados"
                  ></v-autocomplete>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-3" style="display: flex; align-items: center">Excepciones Permitidas</div>
              <div class="col-9">
                <div style="max-width: 250px">
                  <v-autocomplete
                    hide-details
                    v-model="formNew.excepcion"
                    :items="excepcionesPermitidas"
                    label="Seleccionar"
                    solo
                    dense
                    no-data-text="No se obtuvieron resultados"
                  ></v-autocomplete>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-3" style="display: flex; align-items: center">Fecha</div>
              <div class="col-9">
                <div style="max-width: 250px">
                  <v-dialog ref="dialogDate" v-model="modal" :return-value.sync="formNew.fecha_creacion" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        v-model="formNew.fecha_creacion"
                        dense
                        label="Fecha de inicio"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="formNew.fecha_creacion" :min="this.today" scrollable locale="es">
                      <v-spacer></v-spacer>
                      <v-btn text @click="modal = false"> Cancelar </v-btn>
                      <v-btn text color="primary" @click="$refs.dialogDate.save(formNew.fecha_creacion)"> Aceptar </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-3" style="display: flex; align-items: center">Hora Inicio</div>
              <div class="col-9">
                <div style="max-width: 250px">
                  <v-dialog ref="dialogTime" v-model="modal3" :return-value.sync="formNew.hora_inicio" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <div style="max-height: 38px">
                        <v-text-field
                          hide-details
                          style="height: 38px !important"
                          solo
                          v-model="formNew.hora_inicio"
                          label="Hora Inicio"
                          prepend-inner-icon="mdi-clock-time-four-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </div>
                    </template>
                    <v-time-picker v-if="modal3" v-model="formNew.hora_inicio" full-width>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal3 = false"> Cancelar </v-btn>
                      <v-btn text color="primary" @click="$refs.dialogTime.save(formNew.hora_inicio)"> Aceptar </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-3" style="display: flex; align-items: center">Hora Final</div>
              <div class="col-9">
                <div style="max-width: 250px">
                  <v-dialog ref="dialogTime2" v-model="modal2" :return-value.sync="formNew.hora_final" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        hide-details
                        v-model="formNew.hora_final"
                        label="Hora Final"
                        solo
                        prepend-inner-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker v-if="modal2" :min="formNew.hora_inicio" v-model="formNew.hora_final" full-width>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal2 = false"> Cancelar </v-btn>
                      <v-btn text color="primary" @click="$refs.dialogTime2.save(formNew.hora_final)"> Aceptar </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </div>
              </div>
            </div>
          </div>
          <div>
            <v-row class="fill-height">
              <v-col>
                <v-sheet height="64" style="width: 400px">
                  <v-toolbar flat>
                    <v-toolbar-title v-if="$refs.calendar">
                      {{ $refs.calendar.title }}
                    </v-toolbar-title>
                  </v-toolbar>
                </v-sheet>
                <v-sheet height="350">
                  <v-calendar
                    ref="calendar"
                    v-model="formNew.fecha_creacion"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :type="type"
                    @click:more="viewDay"
                    @click:date="viewDay"
                    @change="updateRange"
                  ></v-calendar>
                </v-sheet>
              </v-col>
            </v-row>
          </div>
        </div>

        <!-- :disabled="!formNew.agente || !formNew.excepcion || !formNew.fecha_creacion || !formNew.hora_inicio || !formNew.hora_final" -->
        <hr />
        <div class="text-right">
          <v-btn depressed class="mr-2" color="error" style="width: 120px" @click="Cancelar_Oferta()">Cancelar</v-btn>
          <v-btn
            :disabled="!formNew.agente || !formNew.excepcion || !formNew.fecha_creacion || !formNew.hora_inicio || !formNew.hora_final"
            depressed
            color="success"
            style="width: 80px"
            @click="Crear_Oferta()"
            >Crear</v-btn
          >
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import GeneralMixin from "@/components/mixins/General";
import _ from "lodash";

import { mapState, mapActions } from "vuex";
import PaginationFooter from "@/components/General/PaginationFooter";
import axios from "axios"; // Importar Axios en el componente

export default {
  mixins: [GeneralMixin],
  components: {
    PaginationFooter,
  },
  data: function () {
    return {
      url: process.env.VUE_APP_URL,
      time: null,
      modal2: false,
      modal3: false,
      date: "",
      modal: false,
      datatable: null,
      loading: "",
      result: "",
      ofertas: [],
      newOffer: false,
      formNew: {
        agente: null,
        fecha_creacion: null,
        hora_inicio: null,
        hora_final: null,
        excepcion: null,
      },
      mus: [],
      longitud_minima: [
        { value: "1800", item: "00:30" },
        { value: "3600", item: "01:00" },
        { value: "5400", item: "01:30" },
        { value: "7200", item: "02:00" },
        { value: "9000", item: "02:30" },
        { value: "10800", item: "03:00" },
        { value: "12600", item: "03:30" },
        { value: "14400", item: "04:00" },
        { value: "16200", item: "04:30" },
        { value: "18000", item: "05:00" },
        { value: "19800", item: "05:30" },
        { value: "21600", item: "06:00" },
        { value: "23400", item: "06:30" },
        { value: "25200", item: "07:00" },
        { value: "27000", item: "07:30" },
        { value: "28800", item: "08:00" },
        { value: "30600", item: "08:30" },
        { value: "32400", item: "09:00" },
        { value: "34200", item: "09:30" },
        { value: "36000", item: "10:00" },
        { value: "39600", item: "10:30" },
        { value: "41400", item: "11:00" },
        { value: "43200", item: "11:30" },
        { value: "45000", item: "12:00" },
      ],
      TiempoExtraEnum: ["Schedule Extension", "Under Time", "Client Schedule Extension"],
      headers: [
        { text: "ID de solicitud", align: "left", value: "idExcepcionSolicitud" },
        { text: "MU", align: "start", value: "mu" },
        { text: "Fecha de creación", align: "left", value: "fecha_creacion" },
        { text: "Supervisor", align: "left", value: "usuario_creacion" },
        { text: "Nombre Agente", align: "left", value: "nomagenteSistema" },
        { text: "Agente", align: "left", value: "idfirmarseSistema" },
        { text: "Codigo de excepción", align: "left", value: "idactividad" },
        { text: "Estado", align: "center", value: "status" },
        { text: "Dia", align: "center", value: "fecha_inicio" },
        { text: "Hora inicio", align: "center", value: "hora_inicio" },
        { text: "Hora fin", align: "center", value: "hora_fin" },
      ],
      items: [],
      itemsBackup: [],
      itemsPerPage: 10,
      filter: {
        nomestatus: [
          { name: "Pendiente de aprobación", id: "POR_APROBAR" },
          { name: "Aprobado", id: "APROBADO" },
          { name: "Rechazado", id: "RECHAZADO" },
          { name: "Enviado", id: "ENVIADO" },
        ],
      },
      send: {
        usuario_creacion: "",
        idactividad: "",
        nomestatus: "",
        mu: "",
      },
      begin: [],
      type: "day",
      modalBegin: false,
      search: "",
      maxPages: 1000,
      agentes: [],
      excepcionesPermitidas: [],
      focus: "",
      events: [],
      calendarioAgente: null,
      colors: ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"],
      typeToLabel: {
        day: "Día",
      },
      today: "",
    };
  },
  mounted() {
    const today = new Date();
    this.today = moment(new Date()).format("YYYY-MM-DD");
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    this.begin = [sevenDaysAgo.toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)];
    this.Consultar();
    this.Excepciones();
  },
  methods: {
    ...mapActions("horarios", ["setComponent"]),
    async Excepciones() {
      this.Cargando();
      try {
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");

        const url = this.url + "/v2/api/admin/excepciones/permitidas/" + this.usuario.usuario.sistema;
        const {
          data: {
            data: { excepcionesPermitidas },
          },
        } = await axios.get(url);
        this.excepcionesPermitidas = excepcionesPermitidas;
        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
      }
    },
    async Consultar() {
      this.Cargando();
      try {
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");

        const url = this.url + "/v2/api/admin/excepciones/solicitudes/list";
        let data = (this.data = {
          fecha_inicio: this.begin[0] + "T00:00",
          fecha_fin: this.begin[1] + "T23:59",
        });
        const { data: items } = await axios.post(url, { data });
        this.items = items.map((obj) => {
          return {
            ...obj,
            fecha_inicio: moment(obj.fecha_inicio).utc().format("DD-MM-YYYY"),
            hora_inicio: moment(obj.fecha_inicio).utc().format("HH:mm"),
            hora_fin: moment(obj.fecha_fin).utc().format("HH:mm"),
            fecha_creacion: moment(obj.fecha_creacion).utc().format("DD-MM-YYYY HH:mm"),
          };
        });
        this.itemsBackup = this.items;
        this.agentes = Array.from(
          new Set(
            Object.values(this.itemsBackup).map(function (item) {
              return JSON.stringify({
                nomagenteSistema: item.nomagenteSistema + " (" + item.idfirmarseSistema + ")",
                idfirmarseSistema: item.idfirmarseSistema,
                idagente: item.idagente,
              });
            })
          )
        ).map(function (item) {
          return JSON.parse(item);
        });

        this.order();

        if (items != null) {
          this.ofertas = items;
        }
        if (this.ofertas.length === 0) {
          swal("No hay ofertas", "Por el momento no hay solicitudes", "info");
        }
        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
      }
    },
    async agenteSeleccionado() {
      try {
        this.Cargando();
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");
        const url = this.url + "v2/api/admin/supervisores/calendario/por/agente";
        if (this.formNew.agente) {
          let data = {
            agente: this.formNew.agente.idfirmarseSistema,
          };
          const { data: item } = await axios.post(url, { data });
          this.calendarioAgente = item;
          this.updateRange();
        }

        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }

        this.loading = "d-none";
        this.result = "";
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
      }
    },
    updateRange() {
      const events = [];
      this.focusEvents = [];
      if (this.calendarioAgente) {
        for (let i = 0; i < this.calendarioAgente.calendario.length; i++) {
          const fechaCompletaTextoInicio = `${this.calendarioAgente.calendario[i].fechaInicioHorario}T${this.calendarioAgente.calendario[i].horaInicioActividad}:00`;
          const timestampInicio = Date.parse(fechaCompletaTextoInicio);

          const fechaInicio = new Date(timestampInicio);

          const fechaCompletaTextoFin = `${this.calendarioAgente.calendario[i].fechaInicioHorario}T${this.calendarioAgente.calendario[i].horaFinActividad}:00`;
          const timestampFin = Date.parse(fechaCompletaTextoFin);

          const fechaFin = new Date(timestampFin);
          if (this.calendarioAgente.calendario[i].fechaActividad === this.focus) {
            this.focusEvents.push(this.calendarioAgente.calendario[i]);
          }

          events.push({
            name: this.calendarioAgente.calendario[i].idactividad,
            start: fechaInicio,
            end: fechaFin,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: true,
          });
        }
      }

      this.focusEvents.sort((a, b) => {
        const horaInicioA = a.horaInicioActividad;
        const horaInicioB = b.horaInicioActividad;

        if (horaInicioA < horaInicioB) {
          return -1;
        } else if (horaInicioA > horaInicioB) {
          return 1;
        } else {
          return 0;
        }
      });

      this.events = events;
      this.loading = "d-none";
      this.result = "";
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    order() {
      let data = this.send;
      this.items = _.filter(this.itemsBackup, function (o) {
        return (
          (data.usuario_creacion ? o.usuario_creacion == data.usuario_creacion : true) &&
          (data.idactividad ? o.idactividad == data.idactividad : true) &&
          (data.nomestatus ? o.status == data.nomestatus : true) &&
          (data.mu ? o.mu == data.mu : true)
        );
      });
    },
    Mostrar_Result() {
      this.loading = "d-none";
      this.result = "";
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Nueva_Oferta() {
      this.newOffer = true;
    },
    Cancelar_Oferta() {
      this.newOffer = false;
      this.formNew.agente = {};
      this.formNew.fecha_creacion = "";
      this.formNew.hora_inicio = "";
      this.formNew.hora_final = "";
    },
    async Crear_Oferta() {
      try {
        this.Cargando();
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");
        const url = this.url + "/v2/api/admin/excepciones/solicitudes";
        let data = {
          idagente: this.formNew.agente.idagente,
          idactividad: this.formNew.excepcion,
          fecha_inicio: this.formNew.fecha_creacion + "T" + this.formNew.hora_inicio,
          fecha_fin: this.formNew.fecha_creacion + "T" + this.formNew.hora_final,
        };
        await axios.post(url, { data });

        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }

        this.loading = "d-none";
        this.result = "";
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
      }
    },
    cleanFilter() {
      for (let key in this.send) {
        this.send[key] = "";
      }
      this.Consultar();
    },
  },
  computed: {
    ...mapState({
      usuario: (state) => state.menu.menu.usuario,
    }),
    dateRangeText() {
      return this.begin.join(" ~ ");
    },
    titleDateFormat() {
      // Aquí puedes incluir la clase personalizada en la cadena de formato de fecha
      return (date) => {
        return this.$vuetify.lang.t("Fechas seleccionadas");
      };
    },
  },
};
</script>
<style>
.checkbox-oferta-encendida {
  transform: scale(1.5);
}

.checkbox-regla-48-horas {
  transform: scale(1.5);
}
.v-text-field.v-text-field--solo .v-input__control {
  min-height: 38px;
}
</style>
